import { connect } from 'react-redux';
import { getFrameDimensions } from '@marvelapp/core';
import BodyStyle from '../components/BodyStyle';
import { getFrame } from '../selectors/project';
import { bodyNeedsDeviceHeight } from '../selectors/statusBar';
function mapStateToProps(state) {
    var style = {};
    if (bodyNeedsDeviceHeight(state)) {
        var frame = getFrame(state);
        var height = getFrameDimensions(frame).height;
        style.height = "".concat(height, "px");
    }
    return { style: style };
}
export default connect(mapStateToProps)(BodyStyle);
